import { string, bool, shape, number, arrayOf, oneOfType } from 'prop-types';

const selectOptionPropTypes = shape({
  value: oneOfType([number, string, bool]),
  label: string,
  code: string,
});

const preventiveTaskBasicInformationPropTypes = {
  id: number.isRequired,
  companyPreventiveTaskId: string,
  name: string.isRequired,
  description: string,

  actionType: oneOfType([string, number, selectOptionPropTypes]).isRequired,

  active: oneOfType([bool, number, selectOptionPropTypes]),

  priority: oneOfType([string, number, selectOptionPropTypes]).isRequired,

  deviation: number,

  repeatType: oneOfType([string, number, selectOptionPropTypes]).isRequired,

  repeatInterval: number.isRequired,

  createDate: number,
  lastUpdate: number,
};

const preventiveTaskBasicInformationDefaultProps = {
  companyPreventiveTaskId: null,
  description: null,
  active: true,
  deviation: null,
  createDate: null,
  lastUpdate: null,
};

const preventiveTaskWeekdayPropTypes = {
  id: number,
  preventiveTaskId: number,
  weekday: oneOfType([number, string, selectOptionPropTypes]).isRequired,
};

const preventiveTaskWeekdayDefaultProps = {
  id: null,
  preventiveTaskId: null,
};

const preventiveTaskMonthlyDayPropTypes = {
  id: number,
  preventiveTaskId: number,
  dayOfMonth: number,
  isLastDayOfMonth: bool,
  lastDayOfMonth: bool,
};

const preventiveTaskMonthlyDayDefaultProps = {
  id: null,
  preventiveTaskId: null,
  dayOfMonth: null,
  isLastDayOfMonth: false,
  lastDayOfMonth: false,
};

const preventiveTaskMonthlyRulePropTypes = {
  id: number,
  preventiveTaskId: number,

  monthlyType: oneOfType([string, number, selectOptionPropTypes]).isRequired,

  weekOrder: oneOfType([number, string, selectOptionPropTypes]),

  weekday: oneOfType([number, string, selectOptionPropTypes]).isRequired,
};

const preventiveTaskMonthlyRuleDefaultProps = {
  id: null,
  preventiveTaskId: null,
  weekOrder: null,
};

const preventiveTaskChecklistItemPropTypes = {
  id: number,
  preventiveTaskId: number,
  name: string.isRequired,
  description: string,
  createDate: number,
  lastUpdate: number,
};

const preventiveTaskChecklistItemDefaultProps = {
  id: null,
  preventiveTaskId: null,
  description: null,
  createDate: null,
  lastUpdate: null,
};

const preventiveTaskFullInformationPropTypes = {
  ...preventiveTaskBasicInformationPropTypes,

  weekdays: arrayOf(shape(preventiveTaskWeekdayPropTypes)),

  monthlyDays: arrayOf(shape(preventiveTaskMonthlyDayPropTypes)),

  monthlyRules: arrayOf(shape(preventiveTaskMonthlyRulePropTypes)),

  checklistItems: arrayOf(shape(preventiveTaskChecklistItemPropTypes)),
};

const preventiveTaskFullInformationDefaultProps = {
  ...preventiveTaskBasicInformationDefaultProps,
  weekdays: [],
  monthlyDays: [],
  monthlyRules: [],
  checklistItems: [],
};

/* ============================================================
   PREVENTIVE TASK ASSIGNEE
   ============================================================ */

const preventiveTaskAssigneeBasicInformationPropTypes = {
  id: number.isRequired,

  preventiveTaskId: number.isRequired,

  preventiveTask: shape(preventiveTaskFullInformationPropTypes),

  assignmentScope: oneOfType([string, number, selectOptionPropTypes])
    .isRequired,

  departamentId: number,
  departamentName: string,

  areaId: number,
  areaName: string,

  positionId: number,
  positionName: string,

  userId: number,

  active: oneOfType([bool, number, selectOptionPropTypes]),

  createDate: number,
  lastUpdate: number,
};

const preventiveTaskAssigneeBasicInformationDefaultProps = {
  preventiveTask: null,

  departamentId: null,
  departamentName: null,

  areaId: null,
  areaName: null,

  positionId: null,
  positionName: null,

  userId: null,

  active: true,

  createDate: null,
  lastUpdate: null,
};

const preventiveTaskAssigneeFormPropTypes = {
  preventiveTaskId: oneOfType([number, string, selectOptionPropTypes]),

  assignmentScope: oneOfType([string, number, selectOptionPropTypes]),

  departmentId: oneOfType([number, string, selectOptionPropTypes]),

  departamentId: oneOfType([number, string, selectOptionPropTypes]),

  areaId: oneOfType([number, string, selectOptionPropTypes]),

  positionId: oneOfType([number, string, selectOptionPropTypes]),

  userId: oneOfType([number, string, selectOptionPropTypes]),

  active: oneOfType([bool, number, selectOptionPropTypes]),
};

const preventiveTaskAssigneeFormDefaultProps = {
  preventiveTaskId: null,
  assignmentScope: null,

  departmentId: null,
  departamentId: null,

  areaId: null,

  positionId: null,

  userId: null,

  active: true,
};

const preventiveTaskAssigneeFullInformationPropTypes = {
  ...preventiveTaskAssigneeBasicInformationPropTypes,
};

const preventiveTaskAssigneeFullInformationDefaultProps = {
  ...preventiveTaskAssigneeBasicInformationDefaultProps,
};

export {
  selectOptionPropTypes,
  preventiveTaskBasicInformationPropTypes,
  preventiveTaskBasicInformationDefaultProps,
  preventiveTaskWeekdayPropTypes,
  preventiveTaskWeekdayDefaultProps,
  preventiveTaskMonthlyDayPropTypes,
  preventiveTaskMonthlyDayDefaultProps,
  preventiveTaskMonthlyRulePropTypes,
  preventiveTaskMonthlyRuleDefaultProps,
  preventiveTaskChecklistItemPropTypes,
  preventiveTaskChecklistItemDefaultProps,
  preventiveTaskFullInformationPropTypes,
  preventiveTaskFullInformationDefaultProps,
  preventiveTaskAssigneeBasicInformationPropTypes,
  preventiveTaskAssigneeBasicInformationDefaultProps,
  preventiveTaskAssigneeFormPropTypes,
  preventiveTaskAssigneeFormDefaultProps,
  preventiveTaskAssigneeFullInformationPropTypes,
  preventiveTaskAssigneeFullInformationDefaultProps,
};
